import React from "react";
import {Auth, ForgotPassword, Login, ResetPassword, Welcome} from "./../../components";
import { ROUTES } from '../../config/constants'
import Main from "./../../components/cabinet/main";
import Calculator from "./../../components/cabinet/calculator";
import Calculations from "./../../components/cabinet/calculations";
import Applications from "./../../components/cabinet/applications";
import ApplicationDetailPage from "./../../components/cabinet/applications/detail";
import Settings from "./../../components/cabinet/settings";
import DemoCalculator from "../cabinet/demo";
import CalculationPage from "../cabinet/calculation-page";

import Register from "../auth/register";

export const ROUTES_DEFAULT_ARRAY = [
  {
    path: '/',
    element: <Auth />,
  },
  {
    path: ROUTES.LOGIN,
    element: <Login />,
  },
  {
    path: ROUTES.FORGOT_PASSWORD,
    element: <ForgotPassword />,
  },
  {
    path: `${ROUTES.RESET_PASSWORD}/:id`,
    element: <ResetPassword />,
  },
  {
    path: ROUTES.REGISTER,
    element: <Register />,
  },
  {
    path: ROUTES.WELCOME,
    element: <Welcome />,
  },
  {
    path: ROUTES.DEMO,
    element: <DemoCalculator />,
  }
]

export const ROUTES_CALCULATION_PAGE_ARRAY = [
  {
    path: `${ROUTES.CABINET}/${ROUTES.CALCULATOR_VIEW}/:id`,
    element: <CalculationPage />,
  },
]

export const ROUTES_APPLICATIONS_ARRAY = [
  {
    path: ROUTES.APPLICATIONS,
    element: <Applications />,
  },
  {
    path: `${ROUTES.APPLICATIONS}/${ROUTES.APPLICATIONS_MANAGER}/:publicId`,
    element: <ApplicationDetailPage />,
  },
  {
    path: `${ROUTES.APPLICATIONS}/:publicId`,
    element: <ApplicationDetailPage />,
  },
]

export const ROUTES_CABINET_ARRAY = [
  {
    path: '',
    element: <Main />,
  },
  {
    path: ROUTES.CALCULATOR,
    element: <Calculator />,
  },
  {
    path: `${ROUTES.CALCULATOR}/:id`,
    element: <Calculator />,
  },
  {
    path: ROUTES.CALCULATIONS,
    element: <Calculations />,
  },
  {
    path: ROUTES.SETTINGS,
    element: <Settings />,
  }
]
